import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');

export const ReplyActions = styled.div`
  margin-top: 4px;
  color: ${colors.N200};
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/ReplyActions.js